import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function SimpleCharts() {
  return (
    <BarChart
    yAxis={[
      {
        id: "y-axis",
        min: 0,
        max: 100,
        stepSize: 20,
        tickValues: [0, 20, 40, 60, 80, 100], // Customize tick values
        tickFormat: (value) => `${value}%`, // Add units or custom formatting
        style:{
          color: "#1C1D1F",
            fontFamily: "'SF Pro Display', sans-serif", // Ensure to include a fallback font
            fontSize: "16px",
        }
      },
    ]}
      xAxis={[
        {
          id: "barCategories",
          data: ["week 1", "week 2", "week 3", "week 4", "week 5"],
          scaleType: "band",
          style:{
            color: "#1C1D1F",
            fontFamily: "'SF Pro Display', sans-serif", // Ensure to include a fallback font
            fontSize: "16px",
          }
          
        },
      ]}

      series={[
        {
          data: [40, 60, 83, 45, 90],
          color:"#A435F0",
          borderRadius: 8,
          
        },
      ]}
      width={500}
      height={300}
    />
  );
}
